import { render, staticRenderFns } from "./HospitalsComponent.vue?vue&type=template&id=12b09111&scoped=true"
import script from "./HospitalsComponent.vue?vue&type=script&lang=js"
export * from "./HospitalsComponent.vue?vue&type=script&lang=js"
import style0 from "./HospitalsComponent.vue?vue&type=style&index=0&id=12b09111&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b09111",
  null
  
)

export default component.exports